import GLOBALS from '../config/globals';

const OUTCOME_LABELS = {
    so: 'Strikeout', oo: 'Out', bb: 'Walk',
    h1: 'Single', h2: 'Double', h3: 'Triple', hr: 'Home Run',
};

const KNOWN_TEAM_GROUPS = {
    'AL': new Set(['LAA', 'BAL', 'BOS', 'CWS', 'CLE', 'DET', 'HOU', 'KC', 'MIN', 'NYY', 'OAK', 'SAC', 'SEA', 'TB', 'TEX', 'TOR']),
    'NL': new Set(['ARI', 'ATL', 'CHC', 'CIN', 'COL', 'LAD', 'MIA', 'MIL', 'NYM', 'PHI', 'PIT', 'SD', 'SF', 'STL', 'WSH']),
    'AL East': new Set(['BAL', 'BOS', 'NYY', 'TB', 'TOR']),
    'AL Central': new Set(['CLE', 'CWS', 'DET', 'KC', 'MIN']),
    'AL West': new Set(['HOU', 'LAA', 'OAK', 'SAC', 'SEA', 'TEX']),
    'NL East': new Set(['ATL', 'MIA', 'NYM', 'PHI', 'WSH']),
    'NL Central': new Set(['CHC', 'CIN', 'MIL', 'PIT', 'STL']),
    'NL West': new Set(['ARI', 'COL', 'LAD', 'SD', 'SF']),
    'Federal League': new Set(['BLF', 'BRF', 'BUF', 'KCF', 'NEW', 'PTF', 'SLF']),
};

const matchTeamGroup = (teamNameIDs) => {
    if (!teamNameIDs?.length) return null;
    const ids = new Set(teamNameIDs);
    for (const [label, group] of Object.entries(KNOWN_TEAM_GROUPS)) {
        if (ids.size === group.size && [...ids].every(id => group.has(id))) return label;
    }
    return null;
};

export const formatConstraintLabel = (constraint) => {
    switch (constraint.type) {
        case 'maxRarity': {
            const tier = constraint.rarity ? constraint.rarity.charAt(0).toUpperCase() + constraint.rarity.slice(1) : '?';
            const cap = GLOBALS.RARITY_DISPLAY?.[constraint.rarity]?.rating;
            return `⭐ You can only use cards up to ${tier} rarity${cap ? ` (max ${cap} rating)` : ''}`;
        }
        case 'startDownRuns':
            return `📉 You start the game down ${constraint.runs} run${constraint.runs > 1 ? 's' : ''}`;
        case 'forcedOutcome': {
            const label = OUTCOME_LABELS[constraint.outcome] || constraint.outcome?.toUpperCase() || '?';
            const side = constraint.side === 'user' ? 'your' : "your opponent's";
            return `🎯 One of ${side} batters always gets a ${label}`;
        }
        case 'teamOnly': {
            const group = matchTeamGroup(constraint.teamNameIDs);
            if (group) return `⚾ ${group} only`;
            const listed = constraint.teamNameIDs?.join(', ') || 'specific teams';
            return `⚾ You can only use ${listed} players`;
        }
        default:
            return `⚙️ ${constraint.type}`;
    }
};
